import type { ComponentProps } from "react"

export default function Company(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M10.6667 13.3335V2.66683C10.6667 2.31321 10.5262 1.97407 10.2762 1.72402C10.0261 1.47397 9.68697 1.3335 9.33334 1.3335H6.66668C6.31306 1.3335 5.97392 1.47397 5.72387 1.72402C5.47382 1.97407 5.33334 2.31321 5.33334 2.66683V13.3335M2.66668 4.00016H13.3333C14.0697 4.00016 14.6667 4.59712 14.6667 5.3335V12.0002C14.6667 12.7365 14.0697 13.3335 13.3333 13.3335H2.66668C1.9303 13.3335 1.33334 12.7365 1.33334 12.0002V5.3335C1.33334 4.59712 1.9303 4.00016 2.66668 4.00016Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
